// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("./reason/next/Next.bs.js");
let Api = require("./api");
let React = require("react");
let Scalars = require("./scalars/Scalars.bs.js");
let Intercom = require("./reason/common/Intercom.bs.js");
let AuthSession = require("./utils/AuthSession.bs.js");
let UserSession = require("./reason/common/UserSession/UserSession.bs.js");
let Stdlib_Promise = require("@rescript/runtime/lib/js/Stdlib_Promise.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function fetchIntercomHash(prim) {
  return Api.fetchIntercomHash(prim !== undefined ? Primitive_option.valFromOption(prim) : undefined);
}

function IntercomSessionHandler(props) {
  let intercom = Intercom.useIntercom();
  let shutdown = intercom.shutdown;
  let boot = intercom.boot;
  let update = intercom.update;
  let currentUserInfo = UserSession.useCurrentUserInfo();
  let initState = UserSession.useInitState();
  let hasBooted = React.useRef(false);
  let router = Next.useRouter();
  let pathname = Next.Router.pathname(router);
  let isImpersonated = AuthSession.useIsImpersonated();
  let authSession = AuthSession.use();
  React.useEffect(() => {
    let exit = 0;
    switch (initState) {
      case "Unauthenticated" :
        if (currentUserInfo !== undefined) {
          
        } else {
          if (hasBooted.current) {
            shutdown();
          }
          boot(null);
          hasBooted.current = true;
        }
        break;
      case "Agent" :
      case "Client" :
        exit = 1;
        break;
    }
    if (exit === 1 && currentUserInfo !== undefined) {
      let exit$1 = 0;
      switch (currentUserInfo.__typename) {
        case "Agent" :
        case "RegisteredClient" :
          exit$1 = 2;
          break;
        case "__unselected" :
          break;
      }
      if (exit$1 === 2) {
        let id = currentUserInfo.id;
        let emailAddress = currentUserInfo.emailAddress;
        if (authSession !== undefined && authSession.__typename === "AuthSession") {
          let role = authSession.user.role;
          if (isImpersonated) {
            let attrs = Object.fromEntries([[
                "customAttributes",
                Object.fromEntries([[
                    "is_impersonating",
                    true
                  ]])
              ]]);
            if (hasBooted.current) {
              intercom.update(attrs);
            } else {
              boot(attrs);
              hasBooted.current = true;
            }
          } else {
            Stdlib_Promise.$$catch(Api.fetchIntercomHash(authSession.token).then(param => {
              let tmp;
              tmp = role === "AGENT" ? id : `client-` + id;
              let attrs = Object.fromEntries([
                [
                  "userId",
                  tmp
                ],
                [
                  "email",
                  Scalars.EmailAddress.toString(emailAddress)
                ],
                [
                  "userHash",
                  param.hash
                ]
              ]);
              if (hasBooted.current) {
                intercom.update(attrs);
              } else {
                boot(attrs);
                hasBooted.current = true;
              }
            }), async _err => {});
          }
        }
      }
    }
  }, [
    authSession,
    currentUserInfo,
    isImpersonated,
    boot,
    shutdown,
    update,
    initState
  ]);
  React.useEffect(() => {
    if (hasBooted.current) {
      intercom.update();
    }
  }, [
    pathname,
    update
  ]);
  return null;
}

let make = IntercomSessionHandler;

exports.fetchIntercomHash = fetchIntercomHash;
exports.make = make;
/* Next Not a pure module */
